<template>
	<nav class="mod_navigation">
		<ul class="mainnav level_1">
			<li v-if="iscampaingsite()" class="animated nav-item back-button">
				<a @click="goToPage('/mehrleben')">Zurück zur Übersicht</a>
				<span class="icon-campaign-back">
					<span></span>
					<span></span>
				</span>
			</li>
			<li v-if="!iscampaingsite()" class="animated nav-item back-button">
				<a @click="goToPage('/startseite')">Startseite</a>
			</li>
			<li
				v-for="item in sortedNavigation"
				:key="item.id"
				class="animated nav-item"
				:class="(item.children && item.children.length > 0  ? ' submenu '+ item.class:' '+ item.class) +(item.attributes.alias === 'mehr-leben' ? ' mehr-leben':'')"
			>
				<a
					:class="($route.path.split('/')[1] == item.attributes.alias ? 'active' : '')"
					@click="item.attributes.alias === 'mehr-leben' ? ($route.path != '/mehr-leben'  ? goToPage('/mehr-leben'):false): (takeaction($event, item)) "
					v-html="item.attributes.title"
				></a>
				<!-- ADD CLICK FUNCTION TO FALSE -->
				<span v-if="item.children.length" class="icon-toggle-subnav">
					<span></span>
					<span></span>
				</span>
				<ul v-if="item.children.length" class="level_2">
					<li v-for="children in item.children" :key="children.id" class="nav-item">
						<a
							@click="goToPage((item.attributes.alias != 'mehr-leben') ? '/' +item.attributes.alias +'/'+ children.attributes.alias:children.attributes.alias)"
							:class="($route.params.current == children.attributes.alias ? 'active' : '')"
						>{{children.attributes.title}}</a>
					</li>
				</ul>
			</li>
		</ul>
	</nav>
</template>

<script>
	export default {
		data() {
			return {
				apiurl: "https://www.amecke.de/api/v1/pages/",
				modifiedapiurl: "",
				apiurlmodifier: this.$route.params.current,
				apiurl: "https://www.amecke.de/api/v1/pages/",
				data: [],
				sortedNavigation: [],
				sortedNavigationId: [],
				iscampainsite: false
			};
		},
		updated() {},
		mounted() {
			document.querySelector("main").addEventListener("click", () => {
				this.closeAllNavigations();
				this.closeNavigationBackground();
			});
			document.querySelector("footer").addEventListener("click", () => {
				this.closeAllNavigations();
				this.closeNavigationBackground();
			});

			this.getPages();
		},
		methods: {
			takeaction(event, item) {
								if (item.attributes.alias != 'mehr-leben') {
					console.log('true')
				}
				this.iscampaingsite()

					? this.scrolltoAnchor(item.cssID[0])
					: this.toggleNavigation(event);
			},
			goToPage(path) {
				this.sortedNavigation = [];
				this.$router.push(path);
				this.closeAllNavigations();
				this.closeNavigationBackground();
			},
			getPages() {
				this.modifiedapiurl =
					this.apiurl + "?current=" + this.$route.path.replace("/", "");
				axios
					.get(this.modifiedapiurl, {})
					.then(response => {
						this.data = response.data.data;

						for (var i = 0; i < this.data.length; i++) {
							var item = this.data[i];
							if (
								item.attributes.published == "1" &&
								(item.attributes.hide == "" ||
									item.attributes.isCampaingsite == "1")
							) {
								
								var itemId = this.data[i].id;
								item.children = [];

								this.data.forEach(function(value, key) {
									var child = value;
									var childId = key;

									if (
										child.attributes.pid === itemId &&
										child.attributes.pid != 49
									) {
										item.children.push(child);
									}
								});

								if (
									item.attributes.pid === 1 ||
									(item.attributes.isCampaingsite === "1" &&
										!item.attributes.hide)
								) {
									if (
										!this.sortedNavigationId.includes(item.id)
									) {
										this.sortedNavigation.push(item);
										this.sortedNavigationId.push(item.id);
									}
								}
							}

						}
							
					})
					.catch(function(error) {
						console.error(error);
					});
			},
			toggleNavigation(event) {
				// this.closeAllNavigations();
				// open current navigation
				let elementBody = document.querySelector("body");
				// class for height nav-background
				elementBody.classList.add("js-nav-background");
				// li-item of clicked element
				let targetElement = event.target.parentNode;
				// console.log(targetElement.classList);
				if (targetElement) {
					if (targetElement.classList.contains("js-active")) {
						this.closeAllNavigations();
					} else {
						// close all navigation
						this.closeAllNavigations();
						targetElement.classList.add("js-active");
					}
				}
			},
			getOffset(el) {
				const rect = el.getBoundingClientRect();

				return {
					left: rect.left,
					top: rect.top + window.pageYOffset - 20
				};
			},
			scrolltoAnchor(id) {
				let elementBody = document.querySelector("body");
				elementBody.classList.remove("js-mobilenav-is-active");
				let element = document.getElementById(id);
				let accTopPos = parseInt(this.getOffset(element).top - 100);
				// console.log("click: " + id + " AccPos: " + accTopPos);
				if (
					elementBody.classList.contains("ie") ||
					elementBody.classList.contains("edge")
				) {
					window.scroll(0, accTopPos);
				} else {
					window.scrollTo({
						top: 0,
						left: 0
					});
					window.scrollTo({
						top: accTopPos,
						left: 0,
						behavior: "smooth"
					});
				}
			},
			closeNavigationBackground() {
				let bodyElement = document.querySelector("body");
				if (bodyElement) {
					bodyElement.classList.remove(
						"js-mobilenav-is-active",
						"js-nav-background"
					);
				}
			},
			closeAllNavigations() {
				let allNavItems = document.querySelectorAll(".level_1 > .nav-item");

				if (allNavItems) {
					[].forEach.call(allNavItems, el => {
						el.classList.remove("js-active");
					});
				}
			},
			iscampaingsite() {
				return document.body.classList.contains("site-campaign");
			}
		},
		computed: {},
		watch: {
			$route(to, from) {
				this.sortedNavigation = [];
				this.sortedNavigationId = [];
				this.sortedNavigation = [];
				this.modifiedapiurl = to.path;
				this.getPages();
			}
		}
	};
</script>

<style lang="scss" scoped>
	@import "@/scss/variables.scss";
	@import "@/scss/mixins.scss";;

	// navigation variables
	$nav-mobile-alpha: 0.8;
	$nav-spaceer-icon: "data:image/svg+xml,%3Csvg version='1.1' id='icon-nav-spacer' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 70 4' style='enable-background:new 0 0 70 4;' xml:space='preserve'%3E%3Ccircle style='fill:%23175d3b;' class='st0' cx='35' cy='2' r='2'/%3E%3C/svg%3E";

	// main navigation
	.mod_navigation {
		// background: rgba($color-white-rgb, $nav-mobile-alpha);
		background: linear-gradient(
			to top,
			#ffffff,
			rgba(#ffffff, 0.4),
			rgba(#ffffff, 0.3),
			rgba(#ffffff, 0)
		);
		position: relative;
		// margin-left: 20px;
		margin-top: 20px;
		width: 100%;

		@include min-screen($screen-min-m) {
			background: transparent;
			margin: 50px 0 20px 150px;
			width: 100%;
			max-width: $maxwidth-wrapper;
		}

		ul {
			list-style: none;
			margin: 0;
			padding: 0;

			li {
				display: block;
				margin: 0;

				@include min-screen($screen-min-m) {
					display: inline-block;
				}
			}
			// nav-item global
			.nav-item {
				> a {
					display: block;
					@include font-TheMix("semibold");
					font-size: 18px;
					&:focus {
						outline: none;
					}

					@include min-screen($screen-min-m) {
						// padding-left: 35px;
						// padding-right: 35px;
						margin-left: 35px;
						margin-left: 15px;
						// margin-right: 15px;
						margin-right: 5px;
						position: relative;

						&:before {
							// content: url($nav-spaceer-icon);
							color: $color-green;
							content: "•";
							// left: -20px;
							left: -39px;
							left: -15px;
							text-align: center;
							position: absolute;
							top: 1px;
							// width: 35px;
							width: 8px;
						}
						&:after {
							content: "";
							height: 1px;
							border: 0 solid $color-green;
							width: 0;
							position: absolute;
							bottom: -2px;
							left: 0;
							transition: width 0.25s ease-in-out,
								border-width 0.25s ease-in-out;
						}
						&:hover,
						&.active {
							&:after {
								width: 100%;
								border-width: 0 0 1px 0;
							}
						}
					}
				}

				&.submenu {
					padding-right: 30px;
					position: relative;

					.icon-toggle-subnav {
						// border: 1px solid #f00;
						display: inline-block;
						height: 30px;
						pointer-events: none;
						position: absolute;
						right: $wrapper-padding;
						top: 17px;
						width: 30px;
						z-index: 2;

						span {
							background-color: $color-green;
							border-radius: 3px;
							display: block;
							height: 3px;
							left: 0;
							position: absolute;
							transition: all 0.3s ease-in-out;
							width: 20px;
							z-index: 1;

							&:nth-child(1) {
								left: -2px;
								top: 12px;
								transform: rotate(45deg);
							}

							&:nth-child(2) {
								left: 10px;
								top: 12px;
								transform: rotate(-45deg);
							}
						}
					}

					&.js-active {
						.icon-toggle-subnav {
							span {
								&:nth-child(1) {
									left: -2px;
									top: 12px;
									transform: rotate(-45deg);
								}

								&:nth-child(2) {
									left: 10px;
									top: 12px;
									transform: rotate(45deg);
								}
							}
						}
					}
				}

				@include min-screen($screen-min-m) {
					&:first-child {
						> a,
						> span {
							padding-left: 0;

							&:before {
								content: "";
							}
						}
					}

					&.submenu {
						padding-right: 0;
						// position: relative;

						.icon-toggle-subnav {
							display: none;
						}
					}
				}
			}

			// level 1
			&.level_1 {
				height: 0;
				opacity: 0;
				padding: 0;
				overflow: hidden;
				transition: all 0.25s ease-in-out;
				@include min-screen($screen-min-m) {
					height: auto;
					opacity: 1;
					overflow: visible;
				}
				.js-mobilenav-is-active & {
					height: auto;
					opacity: 1;
					overflow: visible;
					z-index: 2;
				}

				// level 1 nav-item
				> .nav-item {
					border-bottom: 1px solid $color-green;
					padding: 20px 30px 20px $wrapper-padding;

					// level 2
					> .level_2 {
						height: 0;
						opacity: 0;
						padding: 0;
						overflow: hidden;
						transition: all 0.25s ease-in-out;
						width: 100%;
						z-index: -1;
						// level 2 nav-item
						> .nav-item {
							padding: 10px 0 10px 10px;
							&:first-child {
								padding-top: 20px;
							}
						}
						@include min-screen($screen-min-m) {
							left: 0;
							padding: 0;
							position: absolute;

							> .nav-item {
								padding: 0;
							}
						}
					}
					// level 1 active
					&.js-active {
						> .level_2 {
							height: auto;
							opacity: 1;
							overflow: visible;
							z-index: 2;
							@include min-screen($screen-min-m) {
								padding: 25px 0;
								li {
									&:first-child {
										a {
											margin-left: 0;
										}
									}
								}
							}
						}
					}

					@include min-screen($screen-min-m) {
						position: static;
						border-bottom: none;
						// opacity: 0;
						padding: 0;
						&:first-child {
							> a {
								margin-left: 0;
							}
						}
					}
				}
			}
		}
	}
</style>